import { combineReducers } from 'redux';
import input from './input.js';

const reducers = combineReducers({
  input,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js